var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2628 1080",
    width: 153,
    height: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#193560}.b{fill:#fbb315}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1089.6 314.3h-210.2c0 0-1.9 75 84.4 72.2 0 0 70.8-3.5 105.5-25.2v74.4c0 0-73.6 39-177.9 16.1-104.3-22.9-115.3-127.8-114.7-158.1 0.6-30.4 3-44.3 3-44.3h308.6l1.3 64.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m937.8 187.1c0 0 53.5-5.4 58.3 62.3h92.2c0 0 1.9-128.3-150.5-131.3-152.4-3.1-159.9 148.5-159.9 148.5l102.8-17.2c0 0-9.6-54.2 57.1-62.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m776.7 293.7c0 0-6.4-97.8 60-145.5l166 51.5-22.8 4.7c0 0-34.3-34.2-78.4-2.1 0 0-20.2 17.2-20.2 50.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1223.6 266.6l117.5-142.6h117.9l-128.6 142.6 133.7 186.9-116-0.5-84-124.5-39 28v96.5h-100v-370.8c0-44.9 36.4-81.2 81.2-81.2h19.1c0 0-1.8 265.6-1.8 265.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1447.6 158v40.2h42.3v151.5c0 0-7.3 109.3 97.7 110.3 0 0 74-1 94-18v-73c0 0-91.5 41.5-91.5-26.5v-143h88v-75.5h-87.8v-67.5h-64.4l-27.8 70z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2060.4 125.6h73.6l16.1 53.8h6c0 0 31.8-73.7 125.5-55.8l-8 93.7c0 0-77.1-20.5-105.5 32.3-5.5 10.3-8.1 22-8.1 33.7v171.2h-99.6c0 0 0-328.9 0-328.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1857.1 120.6c0 0 161.5-13.9 160.5 171.9-1 173.9-160.5 165-160.5 165v-75.4c0 0 60.4 5 58.5-88.1-2-93.1-31.8-94.5-58.5-97.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1857.1 119.8c0 0-161.5-13.9-160.5 171.9 1 173.8 160.5 165 160.5 165v-75.4c0 0-60.4 5-58.5-88.1 2-93.1 31.8-94.5 58.5-97.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1846 119.6c0 0 25.7-1.5 50.1 3.7l-30.1 74c0 0-33.2-5-50.8 17.6-17.5 22.6-19.5-7.1-19.5-7.1l50.3-88.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1751.5 423.3c0 0 49.6 50.9 148.9 29.6l-12.6-80.5c0 0-14.3 11.7-42.3 7.8l-34 51.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m773.5 625l30.6 68.1c0 0 81.6-40.1 122.4-18 0 0 22.4 6 18.3 50.1h104c0 0 4.1-74.2-40.8-104.2-44.8-30.1-112.1-26.1-112.1-26.1 0 0-81.6 6-122.4 30.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m955 885.5l22.4 48h71.5v-208.4h-104.1l0.7 56.6 1.3 103.8h8.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m881.6 787.3c0 0 17.7-7.2 63.9-5.6v33.1c0 0-0.7 48.6-59.8 50.6v68.1c0 0 38.7-4 69.3-48l20.4-86.2-12.3-32.1-18.3-42.1-63.2 1.4v60.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m845.6 829.3c0 0-4.8 39.7 44.1 35.9v68.3c0 0-65.2 16.1-108-12-42.9-28-40.8-72.1-40.8-100.2 0-28 16.3-91.5 140.7-94.8h13.1l-13.1 60.8c0 0-36.4 5-36 42.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m950.9 881.4h10.2v8.1h-10.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1107 601.3h74.9l16 41.7h4.4c0 0 25.1-45.9 98.4-48.3 73.2-2.4 97.6 48.3 97.6 48.3h6.5c0 0 24.1-48.1 100.9-48.4 76.9-0.2 96.5 50.5 102.4 69.9 5.8 19.5 6.5 59.1 6.5 59.1v211.9h-100.4v-204.5c0-7.6-1.2-15.3-3.8-22.6-5.2-14.8-17.2-34.6-44.2-34.1-21.4 0.3-34.1 12.8-41.5 25.2-6.3 10.6-9.4 22.6-9.4 34.7v201.3h-106.2l0.1-211.2c0 0 0-48.6-49.5-48.6-49.4 0-48 48.6-48 48.6v211.2h-104.7v-334.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1663.5 601h83.9l15.5 43h6.1c0 0 25.1-49.5 90.8-49.4 65.6 0.1 105.6 37.6 125.6 130h-108.2c0 0-7-51-54.2-48.9-47.3 2-51.9 48.9-51.9 48.9h-107.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1768.8 1079.3v-354.7h-105.3v249.5c0 58.1 47.1 105.2 105.3 105.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1771.1 724.6c0 0-20.2 137.7 53.4 134.3 0 0 42.9 2.3 52.7-51.2 9.7-53.5 0-83.1 0-83.1h108.2c0 0 25.9 156-80.5 206.7 0 0-77.8 36.1-136.1-31.3l-15.3-168.1 11.1-26.4 6.5 19.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2017.5 601h102.4v195.9c0 0-3.9 66 45.3 62.5 49.2-3.4 64.8-26.4 64.8-83.3v-175.1h101.6v331.8h-77.4l-13.5-41.4h-5.4c0 0-34.3 66.8-145.9 41.4 0 0-71.9-13-71.9-102.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m2624.2 622.5l-29.9 69.5c0 0-84.6-41.7-120.3-16.6-2.5 1.8-4.2 4.7-4.6 7.8-0.8 7.3 1.2 20.5 23 28.2 31.3 11.2 144.7 43.1 134.5 126.5-10.1 83.4-74 104.2-135.2 102.1 0 0-67.2 0.7-120.9-19.4v-82c0 0 107.7 44.1 147.8 20.5 0 0 30.6-19.5-12.3-42.4-42.8-22.9-120.9-38.9-132.5-98-12.8-65.7 19.1-115.3 102.6-122.9 75.5-6.9 147.8 26.7 147.8 26.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m394.6 45.2c0-24.4 19.8-44.2 44.2-44.2h23.6c24.4 0 44.2 19.8 44.2 44.2v4.6c0 24.4-19.8 44.2-44.2 44.2h-23.6c-24.4 0-44.2-19.8-44.2-44.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m398.6 505h106v189l139-189h110l-140.6 189 140.6 239.5h-113.4l-101.6-174.5-37 25v149.5h-103v-428.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m398.6 124h101v331c-55.8 0-101-45.5-101-101.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m557.6 124h76.4l14.6 54h5.2c0 0 44.7-82 127.3-54l-7.5 92c0 0-114-30-114 83v154h-102z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2303.6 44.2c0-24.4 19.8-44.2 44.2-44.2h23.6c24.4 0 44.2 19.8 44.2 44.2v4.6c0 24.4-19.8 44.2-44.2 44.2h-23.6c-24.4 0-44.2-19.8-44.2-44.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2307.6 123h101v331c-55.8 0-101-45.5-101-101.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m106.6 13.5c0-6.9 5.6-12.5 12.5-12.5 6.9 0 12.5 5.6 12.5 12.5v64c0 6.9-5.6 12.5-12.5 12.5-6.9 0-12.5-5.6-12.5-12.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1087.8 240.9c0 0 1.2 8.3 0.5 12.7l-91.7 1.4-0.5-5.6-0.5-5.7c0 0 92.2-2.8 92.2-2.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1839.6 120h42v76h-42z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1873 709.7c0 0 8.5 22 8 39.2l91.6-8.9 14.4-1.4c0 0-2.1-20.5-6.2-33.1-4.2-12.5-107.8 4.2-107.8 4.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m945.6 720h103v13h-103z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1663.6 717h107v13h-107z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1760.6 810h12v92h-12z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m0 38.6c0 0 58.3 70.4 109.2 68.8v345.4h-109.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m2.7 1c0 0 39.4 87.4 105.1 89h13.1v-89z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m81.1 364.1l0.2 88.2c0 0 191.6 20.3 249-118.7 57.3-138.9 0.4-327.5-209.4-332.6v89c0 0 97.4 0 113 91 15.5 91-3.3 182.2-113 182.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/horizontal.dbfe736b5b55f1736dd4cf8c5f150cf2.svg";
export { ForwardRef as ReactComponent };